var $14a1d1750c9de591$exports = {};
$14a1d1750c9de591$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Izaberite...`
};


export {$14a1d1750c9de591$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
